<div class="my-coupons-card-wrp">
    <div class="coupons-card disabled-cardx">
        <div class="uk-flex brand-offers">
            <div class="brand-logo">
                <img src="{{couponData.merchant.logo}}" class="w-100 fitimg">
            </div>
            <div class="info">
                <h4>{{couponData.merchant.merchant}}</h4>
                <p>{{couponData.offer}}</p>
            </div>
        </div>
        <!--brand-offers end-->

        <div class="details uk-flex brand-coupons uk-flex-between">
            <div class="copy-code w-50 uk-flex uk-flex-middle position-relative">
                <input type="text" [(ngModel)]="couponData.coupon_name" readonly>
                <i [cdkCopyToClipboard]="couponData.coupon_name" class="fa fa-clipboard cursor-pointer" aria-hidden="true"></i>
            </div>
            <a [routerLink]="['/'+appService.getCurrentCity()+'/deals/by/'+couponData.merchant.slug]" class="w-40 btn-yellow text-uppercase">View
        Deal</a>
        </div>
        <!--brand-coupons end-->

        <div class="uk-flex view-more uk-flex-between mt-15 uk-flex-middle">
            <!-- <a class="cursor-pointer" (click)="viewDetails()">{{more ? "+ MORE" : "- LESS"}}</a> -->
            <span>Valid Until {{couponData.end_date}}</span>
        </div>
        <!--view-more end-->

    </div>
    <div class="terms-and-condition-card" *ngIf="showDetails">
        <h4>Terms & conditions appply</h4>
        <ul>
            <li>Lorem ipsum dolor sit amet, consectetu dolor</li>
            <li>Lorem ipsum dolor sit amet, consectetu dolor</li>
            <li>Lorem ipsum dolor sit amet, consectetu dolor</li>
            <li>Lorem ipsum dolor sit amet, consectetu dolor</li>
        </ul>
    </div>
</div>